

export default {
    getFilteredSubKategori : (state) => (id) => state.subKategoriList.filter(v => v.kategori.id === id),
    getIdKategori : (state) => name => state.kategoriList.find(v => v.name === name),
    getIdSubKategori : (state) => name => state.subKategoriList.find(v => v.name === name)
}
